import { render, staticRenderFns } from "./RequirementDialog.vue?vue&type=template&id=c5ba1e38"
import script from "./RequirementDialog.vue?vue&type=script&lang=js"
export * from "./RequirementDialog.vue?vue&type=script&lang=js"
import style0 from "./RequirementDialog.vue?vue&type=style&index=0&id=c5ba1e38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports